export const images = {
  logo: "/assets/logo.png",
  logoFree: "/assets/logo_free.png",
  jan: "/assets/us/avatar_jan1.png",
  jens: "/assets/us/avatar_jens.png",
  promo: "assets/web/images/promo.png"
}

export const files = {
  wohfree: "/assets/app/apk/wohfree.apk"
}

 
export const appImages = {
  is_ionian_c: "/assets/app/images/is_ionian_c.png",
  is_classic_ion_sixte_ajoute: "/assets/app/images/is_classic_ion_sixte_ajoute.png",
  mixer_classic_sixte_ajoute: "/assets/app/images/mixer_classic_sixte_ajoute.png",
  is_rock_aeo_i_vi_ii_vii: "/assets/app/images/is_rock_aeo_i_vi_ii_vii.png",
  tt_rock_is_aeo_i_vi_ii_vii: "/assets/app/images/tt_rock_is_aeo_i_vi_ii_vii.png",
  p_proglist: "/assets/app/images/p_proglist.png",
  is_classic_aeo_quintfall: "/assets/app/images/is_classic_aeo_quintfall.png",
  mixer_classic_quintfall: "/assets/app/images/mixer_classic_quintfall.png",
  is_blues_mix_rock_n_roll: "/assets/app/images/is_blues_mix_rock_n_roll.png",
  mixer_blues_mix_rock_n_roll: "/assets/app/images/mixer_blues_mix_rock_n_roll.png",
  mm_jazz_ii_vi_i: "/assets/app/images/mm_jazz_ii_vi_i.png",
  mixer_jazz_aeo_ii_vi_i: "/assets/app/images/mixer_jazz_aeo_ii_vi_i.png",
  p_tt_jazz_aeo_ii_vi_i: "/assets/app/images/p_tt_jazz_aeo_ii_vi_i.png",
  bpm: "/assets/app/images/bpm.png",
  hm_rock_phrygian_ii_vi_i: "/assets/app/images/hm_rock_phrygian_ii_vi_i.png",
  mixer_rock_phrygian_ii_vi_i: "/assets/app/images/mixer_rock_phrygian_ii_vi_i.png",
  is_rock_aeo_scale: "/assets/app/images/is_rock_aeo_scale.png",
  p_tt_rock_scale_aeo: "/assets/app/images/p_tt_rock_scale_aeo.png"
}

   
export const appVideos = {
  //app_promo: "https://www.youtube.com/watch?v=kFSlLPkTyUI&list=PLU8aZADskSYmF5_3aa-bRp_nw0ek20JVn&index=3", app_promo_tn: "/assets/app/videos/app_promo.tn.png",
  app_promo: "/assets/app/videos/app_promo.mp4", app_promo_tn: "/assets/app/videos/app_promo.tn.png",
  //tutorials
  app_systems: "/assets/app/videos/app_systems.mp4", app_systems_tn: "/assets/app/videos/app_systems.tn.png",
  app_progressions: "/assets/app/videos/app_progressions.mp4", app_progressions_tn: "/assets/app/videos/app_progressions.tn.png",
  app_mixer_user: "/assets/app/videos/app_mixer_user.mp4", app_mixer_user_tn: "/assets/app/videos/app_mixer_user.tn.png",
  app_mixer_progression: "/assets/app/videos/app_mixer_progression.mp4", app_mixer_progression_tn: "/assets/app/videos/app_mixer_progression.tn.png",
  //examples
  app_jazz_iivi: "/assets/app/videos/app_jazz_iivi.mp4", app_jazz_iivi_tn: "/assets/app/videos/app_jazz_iivi.tn.png",
  app_blues: "/assets/app/videos/app_blues.mp4", app_blues_tn: "/assets/app/videos/app_blues.tn.png"
}

export const webVideos = {
  web_promo: "/assets/web/videos/web_promo.mp4", web_promo_tn: "/assets/web/videos/web_promo.tn.png",
  //tutorials
  web_systems: "/assets/web/videos/web_systems.mp4", web_systems_tn: "/assets/web/videos/web_systems.tn.png",
  web_progressions: "/assets/web/videos/web_progressions.mp4", web_progressions_tn: "/assets/web/videos/web_progressions.tn.png",
  //web_mixer_user: "/assets/web/videos/web_mixer_user.mp4", web_mixer_user_tn: "/assets/web/videos/web_mixer_user.tn.png",
  //web_mixer_progression: "/assets/web/videos/web_mixer_progression.mp4", web_mixer_progression_tn: "/assets/app/videos/web_mixer_progression.tn.png",
  //examples
  web_jazz_iivi: "/assets/web/videos/web_jazz_iivi.mp4", web_jazz_iivi_tn: "/assets/web/videos/web_jazz_iivi.tn.png",
  //web_blues: "/assets/web/videos/web_blues.mp4", web_blues_tn: "/assets/web/videos/web.tn.png"
}